// src/components/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Скроллит страницу вверх при смене маршрута.
 * Также корректно обрабатывает якоря (#hash).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // Скролл в начало при смене пути (без хеша)
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);

  // Переход к якорю при наличии hash
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [hash]);

  return null;
}
